import ReactDOM from "react-dom";

export function TooltipPortal({ children }) {
  const tooltipRoot = document.getElementById("tooltip-root");

  if (!tooltipRoot) return children;

  return ReactDOM.createPortal(children, tooltipRoot);
}
